/* unplugin-vue-components disabled */import { render } from "./linkwidthheight.vue?vue&type=template&id=08d1b216&scoped=true"
import script from "./linkwidthheight.vue?vue&type=script&lang=js"
export * from "./linkwidthheight.vue?vue&type=script&lang=js"

import "./linkwidthheight.vue?vue&type=style&index=0&id=08d1b216&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d1b216"]])

export default __exports__